import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../../styles/sections.css';
import '../../styles/climbor-die.css';
import '../../styles/screenshots.css';

import climbOrDie1 from '../../assets/ClimbOrDie1.png';
import climbOrDie2 from '../../assets/ClimbOrDie2.png';
import climbOrDie3 from '../../assets/ClimbOrDie3.png';
import climbOrDie4 from '../../assets/ClimbOrDie4.png';
import climbOrDie5 from '../../assets/ClimbOrDie5.png';
import climbOrDie6 from '../../assets/ClimbOrDie6.png';
import climbOrDie7 from '../../assets/ClimbOrDie7.png';
import climbOrDie8 from '../../assets/ClimbOrDie8.png';
import climbOrDie9 from '../../assets/ClimbOrDie9.png';
import climbOrDie10 from '../../assets/ClimbOrDie10.png';

const Screenshots = () => (
  <div className="screenshots-section">
    <div className="section-header">
      <h2>SCREENSHOTS</h2>
      <div className="underline"></div>
    </div>
    <div className="screenshots-content">
      <div className="screenshots-carousel">
        <Carousel
          showThumbs={false}
          infiniteLoop
          autoPlay
          interval={5000}
          showStatus={false}
          dynamicHeight={false}
        >
          {[climbOrDie1, climbOrDie2, climbOrDie3, climbOrDie4, climbOrDie5, climbOrDie6, climbOrDie7, climbOrDie8, climbOrDie9, climbOrDie10].map((img, idx) => (
            <div key={idx}>
              <img src={img} alt={`CLIMB OR DIE! Screenshot ${idx + 1}`} />
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  </div>
);

export default Screenshots;
